import React from 'react';
import {css} from '@emotion/react';

export const Form = ({name, action, children}) => {
  return (
    <form name={name} onSubmit={(ev) => action(ev)} css={css`
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      input {
        border: 1px solid #ccc;
        padding: 10px 15px;
        font-size: 16px;
        width: 100%;
        border-radius: 4px;

        &.hasError {
          border: 2px solid #f00;
        }
      }

      dl {
        margin: 0 0 30px;
      }
      dt {
        margin: 0 0 10px;
      }
      dd {
        margin: 0;
      }
    `}>
      {children}
    </form>
  )
}

export const FormControl = ({name, children}) => {
  return (
    <div css={css`
      display: flex;
      justify-content: flex-end;
    `}>
      {children}
    </div>
  )
}

export const FormError = ({text}) => {
  return (
    <div css={css`display: flex; align-items: center; margin-top: 10px; color: #f00; font-size: 12px;`}>
      <i className="material-icons" css={css`font-size: 14px; margin-right: 0.3em;`}>error_outline</i>
      {text}
    </div>
  )
}